module.exports = __webpack_public_path__ + "materialdesignicons-webfont.eec7f0f7c8944b878af8.woff";


//////////////////
// WEBPACK FOOTER
// /Users/dendy.anggaditya/Documents/bitbucket/invisee-front-end-jtrust-widget/src/assets/fonts/materialdesignicons-webfont.woff?v=2.0.46
// module id = ../../../../../src/assets/fonts/materialdesignicons-webfont.woff?v=2.0.46
// module chunks = styles